import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import { Message } from "@/components/ui/message/index"
import { Message as MessageType } from "@/reducers/messagesSlice"
import { useMessageData } from "@/components/chat/useMessageData"
import { Phone } from "lucide-react"
import { ChatHistoryContext } from "@/contexts/ChatHistoryContext"

type RetractedMessageProps = {
  message: MessageType
}

const MissedCallMessage: React.FC<RetractedMessageProps> = ({ message }) => {
  const { t } = useTranslation()
  const messageData = useMessageData(message)
  const { isForwardingMode } = useContext(ChatHistoryContext)

  const { missedCallNumber } = message

  return (
    <Message variant="incoming" showAvatar={!isForwardingMode}>
      <Message.Avatar
        src={messageData.avatarSrc}
        name={messageData.authorName}
        fallback={messageData.authorInitials}
        avatarColor={messageData.avatarColor}
      />

      <Message.Bubble withDriver={messageData.isFromDriver}>
        <Message.Header
          author={messageData.authorName}
          timestamp={new Date(message.timestamp)}
        />
        <div>
          <a
            href={`tel:${missedCallNumber}`}
            className="flex items-center gap-2 rounded-md bg-gray-50 p-2 hover:no-underline dark:bg-gray-800"
          >
            <Phone className="h-4 w-4" />
            <p>{t("chat.message.missedCall")}</p>
          </a>
        </div>
      </Message.Bubble>
    </Message>
  )
}

export default MissedCallMessage
